export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10803.fb828fd8.jpg";